module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch015"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0038-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“THE MAIN BRIDGE: Because of this starship’s level of automation, the Bridge on the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" looks very different from the one in the original series. Gone is the need for officers to report to work to what seems a giant cockpit lined with rows of duty stations studded with clusters of instrumentation and controls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Much the same kinds of things happen here as in the old Bridge, but with less emphasis on the mechanics of steering the starship. It is a place where the starship officers with either "), _c('em', [_vm._v("aboard")]), _vm._v(" or "), _c('em', [_vm._v("away")]), _vm._v(" responsibilities can meet, check out information, make plans, et cetera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who actually drives the "), _c('em', [_vm._v("Enterprise")]), _vm._v("? The job of starship command and control is handled by two Bridge duty officers at positions known as "), _c('em', [_vm._v("CONN")]), _vm._v(" and "), _c('em', [_vm._v("OPS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("CONN")]), _vm._v(" (for vessel “control” and navigation). Usually manned by a supernumerary ensign (male or female).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("OPS")]), _vm._v(" (vessel “operations,” including Engineering and Life Support). Position usually manned by Data …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The COMMAND AREA of our Main Bridge is a semi-circle of control seats where the Captain and his next-in-command and advisors are located. Just ahead of this are two FORWARD STATIONS, OPS and CONN positions….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The forward part of the Main Bridge is a large wall-sized ‘Viewer.’ This Main Viewer is usually on and will dominate the Bridge and the action as the original framed viewscreen could never do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The rear of the Bridge has a raised semi-circular area, separated from the Command Area by a railing which is also a set of console stations. This is the TACTICAL CONSOLE. At this position, Worf plus any necessary assistants are responsible for weaponry, defensive devices (shields, etc.), plus ship’s internal security.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The rear wall of the Bridge is an additional set of duty stations called AFT CONSOLES. These five stations represent functions which will also be ordinarily unsupervised unless called for by a story situation….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’ guide, March 23, 1987")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0038-02.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-115fafdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch015.vue
// module id = 117
// module chunks = 0